export default "__VITE_ASSET__D5T4xuS0__"